<template>
  <div class="agencyDetail">
    <div class="banner">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <template v-if="OrgDetail.imageInfoVos">
          <van-swipe-item v-for="item in OrgDetail.imageInfoVos" :key="item.id">
            <img :src="`${urlImg}${item.imgUrl}`" alt="" />
          </van-swipe-item>
        </template>
        <template v-else>
          <van-swipe-item v-for="item in OrgDetail['imgList']" :key="item">
            <img :src="require(`@/assets/images/机构照片${item}`)" alt="" />
          </van-swipe-item>
        </template>
      </van-swipe>
    </div>
    <div class="name">
      {{ OrgDetail.orgName }}
    </div>
    <info-card :item="OrgDetail"></info-card>
    <bottom-button
      word="地图导航"
      :pic="require('@/assets/images/location.png')"
      @right-click="handleComeHereClick"
      :phone="OrgDetail.phone"
    ></bottom-button>
  </div>
</template>

<script>
import { getOrganDetail } from "@/api/agency.js";
import { getDatas } from "@/api/user.js";
import { areaCode } from "@/common/constants.js";
import staticOrgData from "@/common/staticOrgData.json";
import wx from "weixin-js-sdk";
import list from "@/common/staticOrgData.json";

export default {
  name: "agencyDetail",
  data() {
    return {
      urlImg: process.env.VUE_APP_API_IMGURL,
      OrgDetail: {}
    };
  },
  methods: {
    callPhone() {},
    mapNavigate() {},
    async getDetail() {
      let staticOrgIds = ["healthHome1", "ml1", "ml2", "wisdom1", "yly1","healthHome2"];
      // 如果是静态的机构id,则不需要请求后台
      if (staticOrgIds.includes(this.$route.query.orgId)) {
        this.OrgDetail = staticOrgData.list.find(
          item => item.orgId == this.$route.query.orgId
        );
      } else {
        const { data } = await getOrganDetail(this.$route.query.orgId);
        this.OrgDetail = data;
      }
    },
    async config() {
      const thisPageUrl = location.href.split("#")[0];
      const json = {
        url: thisPageUrl
      };
      const res = await getDatas({
        url: json.url,
        areaCode
      });
      wx.config({
        debug: false, // 开启调试模式
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.nonceStr, //生成签名的随机串
        signature: res.signature, //签名
        jsApiList: ["openLocation", "getLocation"] // 必填，需要使用的JS接口列表
      });
    },
    handleComeHereClick() {
      wx.openLocation({
        latitude: parseFloat(this.OrgDetail.latitude), // 纬度，浮点数，范围为90 ~ -90
        longitude: parseFloat(this.OrgDetail.longitude), // 经度，浮点数，范围为180 ~ -180。
        name: this.OrgDetail.orgName, // 位置名
        address: this.OrgDetail.addr, // 地址详情说明
        scale: 15 // 地图缩放级别,整形值,范围从1~28。默认为最大
      });
    }
  },
  mounted() {
    this.config();
    // switch (this.$route.query.orgId) {
    //   case "healthHome1":
    //     return (this.OrgDetail = list["list"].filter(
    //       item => item["orgId"] === "healthHome1"
    //     )[0]);
    //   case "ml1":
    //     return (this.OrgDetail = list["list"].filter(
    //       item => item["orgId"] === "ml1"
    //     )[0]);
    //   case "ml2":
    //     return (this.OrgDetail = list["list"].filter(
    //       item => item["orgId"] === "ml2"
    //     )[0]);
    //   case "wisdom1":
    //     return (this.OrgDetail = list["list"].filter(
    //       item => item["orgId"] === "wisdom1"
    //     )[0]);
    //   case "yly1":
    //     return (this.OrgDetail = list["list"].filter(
    //       item => item["orgId"] === "yly1"
    //     )[0]);
    // }
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.agencyDetail {
  min-height: 100vh;
  padding-bottom: 50px;
  .banner {
    padding: 12px 20px 0 20px;
    .my-swipe {
      width: 335px;
      height: 167px;
      opacity: 1;
      .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 150px;
        text-align: center;
        img {
          width: 100%;
        }
      }
    }
  }
  .name {
    margin-top: 24px;
    // margin-left: 20px;
    padding: 0 20px;
    // width: 270px;
    width: 100%;
    // height: 25px;
    line-height: 25px;
    opacity: 1;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    text-align: left;
    color: #000000;
    margin-bottom: 10px;
  }
  .bottomButton {
    // position: flex;
    position: fixed;
    bottom: 0;
  }
}
</style>
